import api from 'config/Api/Api';

const baseEndpoint = 'v1/payment';

export default {
  getPayments( params ) {
    return api.get( baseEndpoint, params );
  },

  getInvoice( id ) {
    return api.get( `${baseEndpoint}/${id}/invoice` );
  },

  buyCredit( data ) {
    return api.post( `${baseEndpoint}/buy-credit`, data );
  },

  updateBuyCredit( id, data ) {
    return api.put( `${baseEndpoint}/${id}/buy-credit`, data );
  },

  subscribePlan( data ) {
    return api.post( `${baseEndpoint}/buy-plan-credit`, data );
  },

  subscribePlanFee( data ) {
    return api.post( `${baseEndpoint}/buy-plan-free`, data );
  },

  updateSubscription( id, data ) {
    return api.put( `${baseEndpoint}/${id}/buy-plan-credit`, data );
  },

  updatePaymentMethod( id, data ) {
    return api.put( `${baseEndpoint}/${id}/pm`, data );
  },
};
